export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '12,000+', label: '收录漫画' },
    { value: '每日300+', label: '实时更新' },
    { value: '500万+', label: '在线读者' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>全网热门免费漫画大全</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[52px] leading-tight text-foreground-950 mb-4">
              飞飞漫画网 — 海量免费漫画在线畅读
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-5 font-heading">
              下拉式阅读 · 追更无忧
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-7">
              飞飞漫画网汇聚国漫、日漫、韩漫等海量免费漫画资源，无需注册付费即可畅读全站。采用独创下拉式阅读引擎，翻页如丝般顺滑，每日实时同步更新热门连载，让你沉浸式追更，再也不用苦等翻页加载。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline w-full sm:w-auto justify-center"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-foreground-700 rounded-lg font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap no-underline w-full sm:w-auto justify-center"
              >
                热门排行
                <i className="ri-bar-chart-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20illustration%20of%20various%20comic%20and%20manga%20characters%20floating%20dynamically%20on%20a%20warm%20orange%20and%20cream%20gradient%20background%2C%20speech%20bubbles%2C%20action%20lines%2C%20Japanese%20manga%20style%20panels%20scattered%2C%20energetic%20and%20playful%20atmosphere%2C%20clean%20modern%20flat%20illustration%20style%2C%20warm%20lighting%2C%20no%20text%2C%20high%20detail%2C%20artistic%20composition&width=960&height=720&seq=hero-comic-2026&orientation=landscape"
                alt="飞飞漫画网 - 海量免费漫画在线畅读主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}